export const ATTRIBUTE_COVERED_TAG_TEST_ID = 'attribute-covered-tag';
export const ATTRIBUTE_NOT_COVERED_TAG_TEST_ID = 'attribute-not-covered-tag';

export const PLAN_ATTRIBUTES_LABEL_BTN_TEST_ID = 'plan-attributes-label-btn';
export const ATTRIBUTE_ANSWERS_SECTION_TEST_ID = 'attribute-answers-section';
export const COVERED_ATTRIBUTE_SECTION_TEST_ID = 'covered-attribute-section';
export const MAX_WAIVER_NOTE_TEST_ID = 'max-waiver-note';
export const NOT_COVERED_SECTION_TEST_ID = 'not-covered-attribute-section';

export const COLLAPSIBLE_PLAN_ATTRIBUTES_SECTION_TEST_ID = 'collapsible-plan-attributes-section';

export const CHECKLIST_HEADER_TEST_ID = 'checklist-header';
export const ATTRIBUTES_PROGRESS_STATUS_TEST_ID = 'attributes-progress-status';
export const CHECKLIST_HEADER_BACK_BTN_TEST_ID = 'checklist-header-back-btn';

export const TEMPLATE_SIDEBAR_TEST_ID = 'template-sidebar';
export const TEMPLATE_SIDEBAR_REDIRECT_BTN_TEST_ID = 'templates-sidebar-redirect-btn';
export const TEMPLATE_SIDEBAR_MILESTONES_TEST_ID = 'templates-sidebar-milestones';
export const TEMPLATE_SIDEBAR_MILESTONE_ITEM_TEST_ID = 'templates-sidebar-milestones-item';

export const SHELF_PRODUCT_TEMPLATES_STATUS_FILTER_TEST_ID = 'shelf-product-templates-status-filter';
